module.exports = __webpack_public_path__ + "static/fonts/notokr-light.2ea9b0e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey/font/notokr-light.woff
// module id = VTNu
// module chunks = 0